var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-page" },
    [
      _c(
        "div",
        { staticClass: "home_mobile" },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("h1", { staticClass: "title" }, [_vm._v("Make new friends")]),
          _vm._v(" "),
          _c("Appstore", { attrs: { pageName: "home" } }),
        ],
        1
      ),
      _vm._v(" "),
      _c("CategoryFooter"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        staticClass: "logo",
        attrs: { src: "/public/lmk_text@2x.png" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/mobile/Home.vue